export const prepareOptionSelect = (
  options: Array<Record<string, any>>,
  name: string,
  value: string
) =>
  options.map(option => ({
    name: option[name],
    value: option[value],
  }))
